/*
 * Pipeline Theme
 *
 * Use this file to add custom Javascript to Pipeline.  Keeping your custom
 * Javascript in this fill will make it easier to update Pipeline. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 *
 */

(function () {
  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
document.addEventListener('theme:cart:change', function(e) {
  const cart = e.detail.cart;

  // Update drawer cart count
  const drawerCount = document.querySelector('.cart__drawer__count');
  if (drawerCount) {
    drawerCount.innerHTML = `(${cart.item_count})`;
  }

  // Refresh shipping message
  const section = document.querySelector('[data-section-type="cart-drawer"]');
  if (!section) return;
  const sectionId = section.dataset.sectionId;

  fetch(`/?sections=${sectionId}`)
    .then(r => r.json())
    .then(data => {
      const html = new DOMParser().parseFromString(data[sectionId], 'text/html');
      const next = html.getElementById('cart-shipping-message');
      const current = document.getElementById('cart-shipping-message');
      if (next && current) current.replaceWith(next);
    })
    .catch(err => console.error('Cart shipping message refresh failed:', err));
});

 document.addEventListener("theme:variant:change", function (event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log("Container ———————— ↓");
      console.log(container);
      console.log("Variant —————————— ↓");
      console.log(variant);
      // ... update some element on the page

      // Hide all backorder messages first
      const allBackorderAlerts = document.querySelectorAll(
        "[data-variant-backorderalert]"
      );
      allBackorderAlerts.forEach((alert) => {
        alert.style.display = "none";
      });

      // Show the backorder message for the selected variant
      const currentBackorderAlert = document.querySelector(
        `[data-variant-backorderalert="${variant.id}"]`
      );
      if (currentBackorderAlert) {
        currentBackorderAlert.style.display = "block";
      }

      console.log("Displaying backorder alert for variant:", variant.id);

  // Handle backorder variant changes 
const backorderInputs = document.querySelectorAll('[data-variant-backorder]');
const isBackorder = document.querySelector(`[data-variant-backorder="${variant.id}"]`);
let addText = theme.strings.addToCart;

// First, disable all backorder inputs
backorderInputs.forEach(input => {
  input.disabled = true;
});

if (isBackorder) {
  addText = theme.strings.preOrder;
  
  // Enable all inputs that match the current variant
  const currentVariantInputs = document.querySelectorAll(`[data-variant-backorder="${variant.id}"]`);
  currentVariantInputs.forEach(input => {
    input.disabled = false;
  });
} else {
  // If not a backorder variant, ensure all backorder inputs remain disabled
  backorderInputs.forEach(input => {
    input.disabled = true;
  });
}

// Find elements within this container
const addToCart = container.querySelectorAll('[data-add-to-cart]');
const addToCartText = container.querySelectorAll('[data-add-to-cart-text]');

// Update button classes and text

  addToCart.forEach((element) => {
   
    if (isBackorder) {
      element.classList.add('btn--preorder');
      element.classList.remove('btn--primary');
      element.classList.add('btn--secondary');
    } else {
      element.classList.remove('btn--preorder', 'btn--secondary');
      element.classList.add('btn--primary');
    }
  });


// Update button text

  addToCartText.forEach((element) => {
    if (variant.available) {
      element.innerHTML = addText;
    } else {
      element.innerHTML = theme.strings.soldOut;
    }
  });


      // ... end of custom js
    }
  });

 // CUSTOM - variant backorder ship date Initialize on page load
document.addEventListener('DOMContentLoaded', function() {
  // Get the initial selected variant
  const variantInput = document.querySelector('[name="id"]');
  if (variantInput && variantInput.value) {
    const variantId = variantInput.value;
    
    // Hide all backorder messages first
    const allBackorderMessages = document.querySelectorAll('[data-variant-backorder], .product-ship-date');
    allBackorderMessages.forEach(message => {
      message.style.display = 'none';
    });
    
    // Get the backorder message for the selected variant
    const currentBackorderMessage = document.querySelector(`[data-variant-backorder="${variantId}"]`);
    
    // Check if the variant has a non-empty backorder message
    if (currentBackorderMessage && currentBackorderMessage.textContent.trim() !== '') {
      currentBackorderMessage.style.display = 'block';
    } else {
      // If variant message is empty or doesn't exist, show the product-level ship date
      const productShipDate = document.querySelector('.product-ship-date');
      if (productShipDate && productShipDate.textContent.trim() !== '') {
        productShipDate.style.display = 'block';
      }
    }
    
    // Hide all backorder alerts first
    const allBackorderAlerts = document.querySelectorAll('[data-variant-backorderalert]');
    allBackorderAlerts.forEach(alert => {
      alert.style.display = 'none';
    });
    
    // Show the backorder alert for the selected variant
    const currentBackorderAlert = document.querySelector(`[data-variant-backorderalert="${variantId}"]`);
    if (currentBackorderAlert) {
      currentBackorderAlert.style.display = 'block';
    }
    
  // NEW: Handle backorder button text on page load
const isBackorderElement = document.querySelector(`[data-variant-backorder="${variantId}"]`);

const isBackorder = isBackorderElement && isBackorderElement.textContent.trim() !== '';
let addText = theme.strings.addToCart;

if (isBackorder) {
  addText = theme.strings.preOrder;
}

// Find and update button elements
const addToCart = document.querySelectorAll('[data-add-to-cart]');
const addToCartText = document.querySelectorAll('[data-add-to-cart-text]');

// Update button classes and text
if (addToCart.length) {
  addToCart.forEach((element) => {
    if (isBackorder) {  // ← NOW THIS VARIABLE EXISTS
      element.classList.add('btn--backorder');
      element.classList.remove('btn--primary');
      element.classList.add('btn--secondary');
    } else {
      element.classList.remove('btn--backorder', 'btn--secondary');
      element.classList.add('btn--primary');
    }
  });
}
  }
});


  document.addEventListener("theme:cart:change", function (event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log("Cart ———————————— ↓");
      console.log(cart);
      // ... update an app or a custom shipping calculator

      // Custom - Cart Warning Accordion
      // Select the cart warning popup container
      var cartWarningContainer = document.querySelector(
        "[data-accordion-warning]"
      );

      if (cartWarningContainer) {
        // Get the cart subtotal and convert to the same format as in the Liquid code
        var subtotalWithoutCurrency = cart.total_price / 100;
        var minThreshold = parseInt(
          cartWarningContainer.getAttribute("data-limit")
        );
        var maxThreshold = parseInt(
          cartWarningContainer.getAttribute("data-max")
        );

        // Check if the subtotal is between the min and max thresholds
        if (
          subtotalWithoutCurrency >= minThreshold &&
          subtotalWithoutCurrency <= maxThreshold
        ) {
          cartWarningContainer.style.display = "block";
        } else {
          cartWarningContainer.style.display = "none";
        }
      }
    }
  });

  // Fired when page loads to update header values
  document.addEventListener("theme:cart:init", (e) => {
    console.log("theme:cart:init");
    console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  document.addEventListener("theme:scroll", (e) => {
    console.log(e);
  });
  document.addEventListener("theme:scroll:up", (e) => {
    console.log(e);
  });
  document.addEventListener("theme:scroll:down", (e) => {
    console.log(e);
  });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener("theme:resize", (e) => {
    console.log(e);
  });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the
  // scroll locking code knows what element should maintain scroll.
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));

  var links = document.links;
  for (let i = 0, linksLength = links.length; i < linksLength; i++) {
    if (links[i].hostname !== window.location.hostname) {
      links[i].target = "_blank";
      links[i].rel = "noreferrer noopener";
    }
  }
 

/* Javascript - Show cart drawer when product added to cart */
document.addEventListener("theme:cart:popdown", (e) => {
  const listener = (e) => {
    document.querySelector('[data-drawer="drawer-cart"]').dispatchEvent(
      new CustomEvent("theme:drawer:open", {
        bubbles: false,
      })
    );
    document.removeEventListener("theme:cart:change", listener);
  };
  document.addEventListener("theme:cart:change", listener);
});



// Filter product images on page load based on current variant
function filterImagesOnLoad() {
  // Check if we're on a product page
  if (window.location.pathname.includes('/products/') && typeof window.currentVariant !== 'undefined') {
    const currentVariant = window.currentVariant;
    
    if (currentVariant && currentVariant.featured_image && currentVariant.featured_image.alt) {
      const variantImageAlt = currentVariant.featured_image.alt.split('#')[1];
      
      if (variantImageAlt) {
        // Hide images that don't match the current variant
        const thumbs = document.querySelectorAll('[data-slideshow-thumbnail]');
        const slides = document.querySelectorAll('[data-media-slide]');
        
        thumbs.forEach(thumb => {
          const imageFilter = thumb.getAttribute('data-image-filter');
          if (imageFilter === '' || imageFilter === variantImageAlt) {
            thumb.classList.remove('hide');
          } else {
            thumb.classList.add('hide');
          }
        });
        
        slides.forEach(slide => {
          const imageFilter = slide.getAttribute('data-image-filter');
          if (imageFilter === '' || imageFilter === variantImageAlt) {
            slide.classList.remove('hide');
          } else {
            slide.classList.add('hide');
          }
        });
        
        // Refresh sliders if they exist
        refreshSliders();
      }
    }
  }
}

function refreshSliders() {
  const slider = document.querySelector('[data-product-slideshow]');
  const thumbSlider = document.querySelector('[data-product-thumbs]');
  
  if (slider && slider.classList.contains('flickity-enabled')) {
    // Check if FlickityFade is available
    if (typeof FlickityFade !== 'undefined') {
      const flickitySlider = FlickityFade.data(slider);
      if (flickitySlider) flickitySlider.reloadCells();
    }
  }
  
  if (thumbSlider && thumbSlider.classList.contains('flickity-enabled')) {
    // Check if FlickitySync is available
    if (typeof FlickitySync !== 'undefined') {
      const flickityThumbSlider = FlickitySync.data(thumbSlider);
      if (flickityThumbSlider) flickityThumbSlider.reloadCells();
    }
  }
}

// Run on page load
document.addEventListener('DOMContentLoaded', filterImagesOnLoad);

// Also run when page is loaded via AJAX (for themes that use it)
document.addEventListener('shopify:section:load', filterImagesOnLoad);

// Reusable Size Chart Tabs
document.addEventListener('DOMContentLoaded', function() {
  // Find all size chart containers
  const sizeChartContainers = document.querySelectorAll('.size-chart-container');
  
  sizeChartContainers.forEach(container => {
    const tabs = container.querySelectorAll('.size-chart-tab');
    const tables = container.querySelectorAll('.size-chart-table');
    
    tabs.forEach(tab => {
      tab.addEventListener('click', function() {
        const targetTab = this.getAttribute('data-tab');
        
        // Remove active class from all tabs and tables within this container
        tabs.forEach(t => t.classList.remove('active'));
        tables.forEach(table => table.classList.remove('active'));
        
        // Add active class to clicked tab and corresponding table
        this.classList.add('active');
        container.querySelector(`#${targetTab}`).classList.add('active');
      });
    });
  });
});

document.querySelectorAll('.video-autoplay-wrapper').forEach(function(wrapper) {
  const video = wrapper.querySelector('video');
  if (!video) return;

  const controls = document.createElement('div');
  controls.className = 'video-custom-controls';

  controls.innerHTML = `
    <button class="video-play-pause" aria-label="Pause video">
      <svg class="icon-pause" viewBox="0 0 24 24"><rect x="6" y="4" width="4" height="16"/><rect x="14" y="4" width="4" height="16"/></svg>
      <svg class="icon-play" viewBox="0 0 24 24" style="display:none"><polygon points="5,3 19,12 5,21"/></svg>
    </button>
  `;

  wrapper.appendChild(controls);

  const playPauseBtn = controls.querySelector('.video-play-pause');
 

  playPauseBtn.addEventListener('click', function() {
    if (video.paused) {
      video.play();
      playPauseBtn.querySelector('.icon-pause').style.display = '';
      playPauseBtn.querySelector('.icon-play').style.display = 'none';
      playPauseBtn.setAttribute('aria-label', 'Pause video');
    } else {
      video.pause();
      playPauseBtn.querySelector('.icon-pause').style.display = 'none';
      playPauseBtn.querySelector('.icon-play').style.display = '';
      playPauseBtn.setAttribute('aria-label', 'Play video');
    }
  });


});

document.addEventListener('click', function(e) {
  const sizeButton = e.target.closest('[data-size-button]');
  if (!sizeButton) return;
  if (!sizeButton.classList.contains('is-expanded')) {
    sizeButton.blur();
  }
});
// CUSTOM - Klaviyo Notify Me click handler
document.addEventListener('click', function(e) {
  const btn = e.target.closest('.notify-me-trigger');
  if (btn) {
    const formId = btn.getAttribute('data-klaviyo-form');
    if (formId) {
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', formId]);
    }
  }
});

window.parseBundleMapFromDOM = function() {
  var el = document.querySelector('[data-bundle-map]');
  if (!el) return;
  var raw = el.getAttribute('data-bundle-map');
  if (!raw || !raw.trim()) return;

  window.upsellVariantMap = window.upsellVariantMap || {};
  raw.split(';;;').forEach(function(entry) {
    entry = entry.trim();
    if (!entry) return;
    var pipeParts = entry.split('||');
    var colonParts = pipeParts[0].split(':');
    if (colonParts.length !== 2) return;
    window.upsellVariantMap[colonParts[0]] = {
      variantIds: colonParts[1].split(',').filter(Boolean),
      bundleName: pipeParts[1] ? decodeURIComponent(pipeParts[1]) : ''
    };
  });
};

function initUpsellHandler() {
  document.addEventListener('submit', function(e) {
    if (!window.upsellVariantMap) return;

    var productForm = e.target.closest('form[data-product-form], form[action*="/cart/add"]');
    if (!productForm) return;

    var variantInput = productForm.querySelector('input[name="id"]');
    if (!variantInput) return;

    var match = window.upsellVariantMap[variantInput.value];

    if (!match) {
      if (!window.upsellVariantMapReady) {
        e.preventDefault();
        e.stopImmediatePropagation();
        var btn = productForm.querySelector('[type="submit"]');
        setTimeout(function() { if (btn) btn.click(); }, 300);
      }
      return;
    }

    if (!match.variantIds.length) return;
    if (match.inventoryOnly) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    var quantity = parseInt((productForm.querySelector('input[name="quantity"]') || {}).value || '1', 10);
    var submitBtn = productForm.querySelector('[type="submit"]');
    var originalText = submitBtn ? submitBtn.innerHTML : '';
    if (submitBtn) submitBtn.disabled = true;

    var properties = {};

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
      items: match.variantIds.map(function(id) {
  var numericId = id.toString().replace('gid://shopify/ProductVariant/', '');
  var status = match.componentStatus && match.componentStatus[id];
  var properties = {};
  if (status && status.status) {
    properties['Inventory Status'] = status.status;
    if (status.shipDate) {
      properties['Ships'] = status.shipDate;
    }
  }
  return { id: parseInt(numericId, 10), quantity: quantity, properties: properties };
})
      })
    })
    .then(function() {
      return fetch('/cart.js').then(function(r) { return r.json(); });
    })
    .then(function(cart) {
      document.dispatchEvent(new CustomEvent('theme:cart:popdown', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('theme:cart:change', { bubbles: true, detail: { cart: cart } }));

      var quickviewModal = document.querySelector('[data-quickview-modal][aria-hidden="false"]');
      if (quickviewModal) {
        quickviewModal.dispatchEvent(new CustomEvent('theme:quickview:close'));
      }

      setTimeout(function() {
        var cartItems = document.querySelector('[data-drawer="drawer-cart"] .cart__items');
        if (!cartItems) return;

        var existing = document.getElementById('bundle-success-message');
        if (existing) existing.remove();

        var msg = document.createElement('div');
        msg.id = 'bundle-success-message';
        msg.textContent = (match.variantTitle || match.bundleName || 'Bundle') + ' added to cart';

        cartItems.insertBefore(msg, cartItems.firstChild);

        requestAnimationFrame(function() {
          msg.style.opacity = '1';
        });

     document.addEventListener('theme:drawer:close', function() {
  var msg = document.getElementById('bundle-success-message');
  if (msg) msg.remove();
}, { once: true });
      }, 400);
    })
    .catch(function(err) {
      console.error('Bundle add error:', err);
      productForm.submit();
    })
    .finally(function() {
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.innerHTML = originalText;
      }
    });
  }, true);
}

window.parseBundleMapFromDOM();

new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    mutation.addedNodes.forEach(function(node) {
      if (node.nodeType !== 1) return;
      var el = node.matches && node.matches('[data-bundle-map]')
        ? node
        : node.querySelector && node.querySelector('[data-bundle-map]');
      if (el) window.parseBundleMapFromDOM();
    });
  });
}).observe(document.body, { childList: true, subtree: true });

initUpsellHandler();
 // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();
/* end */